import React from "react";

function Product_Details_forms_Edit() {
  return (
    <div className="p-5 border-2 border-gray-200 rounded-xl ">
      {/* Title */}
      <div className="border-b pb-2">
        <p className="text-lg font-semibold text-gray-700">Product Details</p>
      </div>

      {/* Table-like structure */}
      <div className="mt-5 flex px-5 flex-row flex-wrap">
        <table className="w-1/2 text-sm font-medium">
          <tbody>
            {/* Row 1 */}
            <tr>
              <td className="py-3 text-gray-700 w-1/2">Product ID :</td>
              <td className="py-3 w-1/2">P896345</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                HSN Code of Product :
              </td>
              <td className="py-3 w-1/2">01845678</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Default Unit of Measure :
              </td>
              <td className="py-3 w-1/2">Kg</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">Product Capacity :</td>
              <td className="py-3 w-1/2">2,000 Kg</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Production Lead Time in Days :
              </td>
              <td className="py-3 w-1/2">30 Days</td>
            </tr>
          </tbody>
        </table>

        <table className="w-1/2 text-sm font-medium">
          <tbody>
            {/* Row 2 */}
            <tr>
              <td className="py-3 text-gray-700 w-1/2">Product Name :</td>
              <td className="py-3 w-1/2">Emayam Technology ...</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Category of Product :
              </td>
              <td className="py-3 w-1/2">Agriculture & Product...</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Indicative Price Range :
              </td>
              <td className="py-3 w-1/2">$234 - $546</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Present Stock Status :
              </td>
              <td className="py-3 w-1/2">In Stock</td>
            </tr>
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Minimum Order Quantity :
              </td>
              <td className="py-3 w-1/2">3 Kg</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Product_Details_forms_Edit;
